import { render, staticRenderFns } from "./travelInsurance.vue?vue&type=template&id=5c02dfe8&scoped=true&"
import script from "./travelInsurance.vue?vue&type=script&lang=js&"
export * from "./travelInsurance.vue?vue&type=script&lang=js&"
import style0 from "./travelInsurance.vue?vue&type=style&index=0&id=5c02dfe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02dfe8",
  null
  
)

export default component.exports